/*eslint-disable*/
// 表单配置信息
export const collapse = [
    {
        title: '基础信息',
        ref: 'basicForm',
        formName: 'basicInfo',
        col: 4,
        labelWidth: '100px',
        visible: true,
        formList: [
            {
                label: '单据标题',
                prop: 'billTitle',
                value: 'billTitle',
                type: 'input',
                span: 6,
            },
            {
                label: '数据月份',
                prop: 'dataMonth',
                value: 'dataMonth',
                type: 'time',
                format: 'yyyy-MM',
                valueFormat: 'yyyy-MM',
                timeType: 'month',
                span: 4,
                rule: [{ required: true, message: '数据月份必填！', trigger: ['blur', 'change'] }],
            },
            {
                label: '操作类型',
                prop: 'operationType',
                value: 'operationType',
                optionsKey: 'LCRM_INC_OPERATION_TYPE',
                rule: [{ required: true, message: '操作类型必填！', trigger: ['blur', 'change'] }],
                type: 'select',
                span: 4,
            },
            {
                label: '数据类型',
                prop: 'dataType',
                value: 'dataType',
                // optionsKey: 'SYNC_BIG_DATA_TYPE',
                options: {},
                type: 'select',
                rule: [{ required: true, message: '数据类型必填！', trigger: ['blur', 'change'] }],
                span: 4,
            },

            {
                label: '备注',
                prop: 'remark',
                value: 'remark',
                sourceType: 'input',
                inputType: 'textarea',
                type: 'input',
                span: 12,
                rows: 4,
                rule: [{ required: false, message: '备注必填！', trigger: 'change' }],
                disabled: false,
            },
            {
                label: '导入文件',
                prop: 'importDataFiles',
                value: 'importDataFiles',
                type: 'custom',
                span: 23,
                rule: [
                    {
                        required: false,
                        validator: (rule, value, callback) => {
                            if (rule.required && !value.fileUrl) {
                                callback(new Error('导入文件不能为空'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
            },
            {
                label: '其他附件',
                prop: 'respDataManageFiles',
                value: 'respDataManageFiles',
                type: 'custom',
                span: 23,
                rule: [
                    {
                        required: false,
                        validator: (rule, value, callback) => {
                            if (rule.required && !value.length) {
                                callback(new Error('其他附件不能为空'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
            },
        ]
    },
    {
        title: '系统信息',
        ref: 'systemForm',
        formName: 'systemInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '单据编码',
                prop: 'billCode',
                value: 'billCode',
                type: 'custom',
                visible: true,
            },
            {
                label: '审批状态',
                prop: 'approvalStatus',
                value: 'approvalStatus',
                optionsKey: 'LCRM_MIP_STATUS',
                type: 'custom',
            },
            {
                label: '执行状态',
                prop: 'execStatus',
                value: 'execStatus',
                optionsKey: 'SYNC_BIG_DATA_STATUS',
                type: 'custom',
            },
            {
                label: '流程ID',
                prop: 'mipId',
                value: 'mipId',
                type: 'custom',
                visible: true,
            },
            {
                label: '创建人',
                prop: 'createUserName',
                value: 'createUserName',
                type: 'custom',
                visible: true,
            },
            {
                label: '创建时间',
                prop: 'createTime',
                value: 'createTime',
                type: 'custom',
                visible: true,
            },
            {
                label: '修改人',
                prop: 'updateUserName',
                value: 'updateUserName',
                type: 'custom',
                visible: true,
            },

            {
                label: '修改时间',
                prop: 'updateTime',
                value: 'updateTime',
                type: 'custom',
                visible: true,
            },
        ]
    },

];
